import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertProfileContext } from "../../../hooks/expert-profile/ExpertProfileContext";
import { useExpertProfileAddress } from "../../../hooks/expert-profile-address/ExpertProfileAddress";
import { phoneNumberIsInternationalFormat } from "../../../../portal/utils";
import { useAppConfig } from "@limitless/common/hooks";
const AddressForm = ({
  children
}) => {
  var _dialCodes$find;
  const {
    profile,
    saveProfile,
    loading
  } = useExpertProfileContext();
  const {
    config: {
      dialCodes
    }
  } = useAppConfig();
  const country = profile.country || "GB";
  const dialCode = ((_dialCodes$find = dialCodes.find(dc => dc.countryCode === country)) === null || _dialCodes$find === void 0 ? void 0 : _dialCodes$find.dialCode) || 44;
  const {
    address,
    validateAddress,
    handleValueChange,
    getAddressPayload
  } = useExpertProfileAddress(profile);
  const {
    address1,
    address2,
    town,
    postalCode
  } = address;
  const [primaryContactNumber, setPrimaryContactNumber] = React.useState({
    value: profile.primaryContactNumber || dialCode.toString(),
    pristine: true
  });
  const onFormSubmit = () => {
    saveProfile({
      ...getAddressPayload()
    }, () => setPrimaryContactNumber({
      ...primaryContactNumber,
      pristine: true
    }), "Update Profile Details");
  };
  const phoneIsValid = React.useMemo(() => phoneNumberIsInternationalFormat(primaryContactNumber.value, dialCodes), [primaryContactNumber.value]);
  const {
    fieldErrors,
    isFormInvalid
  } = validateAddress(true, {
    primaryContactNumber: {
      ...primaryContactNumber,
      phoneIsValid
    }
  });
  return children({
    address1,
    address2,
    town,
    postalCode,
    primaryContactNumber,
    fieldErrors,
    isFormInvalid,
    onAddressChange: handleValueChange,
    onAddress1Change: value => handleValueChange("address1", value),
    onAddress2Change: value => handleValueChange("address2", value),
    onTownChange: value => handleValueChange("town", value),
    onPostalCodeChange: value => handleValueChange("postalCode", value),
    onPrimaryContactNumberChange: value => setPrimaryContactNumber({
      value,
      pristine: false
    }),
    onFormSubmit,
    loading
  });
};
export default AddressForm;
AddressForm.propTypes = {
  children: PropTypes.func.isRequired
};